import DefaultCarousel from './DefaultCarousel';

export default class FeaturedCarousel extends DefaultCarousel {
  static override get listSignals() {
    return {
      ...super.listSignals,
      onHoveringTileExpansion: 'onHoveringTileExpansion',
    };
  }

  override getExpandedItemWidth(): number | null {
    return this.expandedItemWidth;
  }

  $expandList(transition: object) {
    this.updateFocusStyling(transition);
  }

  $compressList(transition: object) {
    this.updateFocusStyling(transition);
  }

  // On click, expanding tiles will reposition to the first slot as if it was fixed focus and then expand
  onHoveringTileExpansion(index: number) {
    const list = this._List;

    if (list.index !== index) {
      list.setIndex(index);
      list.scroll(list, {
        index: index,
        previousIndex: list.index,
        dataLength: list.length,
      });
    }
  }

  override getFirstItemMaxWidth() {
    return this.getExpandedItemWidth()! + this.getBorderGap();
  }
}
